import { NgModule } from "@angular/core";
import { QrMenaRoutingModule } from "./qrmena-routing.module";
import { ItemsContianerComponent } from "./components/items-container-component/items-container.component";
import { ItemComponent } from "./components/item-component/item.component";
import { CommonModule } from "@angular/common";
import { CashierIndexComponent } from "./cashier/cashier-index-component/cashier-index.component";
import { HeaderComponent } from "@app/shared/layout/header.component";
import { FooterComponent } from "@app/shared/layout/footer.component";
import { RouterModule } from "@angular/router";
import { QrMenaHeader } from "./components/header/header.component";
import { QrFooterComponent } from "./components/footer/footer.component";
import { QRmenaCashierHomeComponent } from "./cashier/cashier-home-component/cashier-home.component";

import { CategoriesContainerComponent } from "./components/categories-container-component/categories-container-component";
import { CategoryItemComponent } from "./components/category-component/category.component";
import { FormsModule } from "@angular/forms";
 
import { QrMenaAuthService } from "./services/qrmena-auth.service";
import { InvoiceItemsComponent } from "./components/invoice-items-component/invoice-items.component";
import { InvoiceItemRecordComponent } from "./components/invoice-item-record-component/invoice-item-record.component";
import { QRMenaToasterComponent } from "./components/toaster/toaste";
import { QrMenaOverlayComponent } from "./components/overlay-component/overlay.component";
import { CategoriesHorizontalContainerComponent } from "./components/categories-container-horizontal-component/categories-container-horizontal.component";
 
@NgModule({
    declarations:[
        ItemsContianerComponent,
        ItemComponent,
        CashierIndexComponent,
        QrMenaHeader,
        QRmenaCashierHomeComponent,
        QrFooterComponent,
        CategoryItemComponent,
        CategoriesContainerComponent,
        InvoiceItemsComponent,
        InvoiceItemRecordComponent,
        QRMenaToasterComponent,
        QrMenaOverlayComponent,
        CategoriesHorizontalContainerComponent
        
      
    ],
    imports:[QrMenaRoutingModule,CommonModule,RouterModule,FormsModule],
    exports:[],
    providers:[QrMenaAuthService]

})
export class QrMenaModule{}




// WEBPACK FOOTER //
// ./src/QrMena/qrmena.module.ts